var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93438 2.82211L11.1782 7.06632L5.3577 12.8947C5.08509 13.1674 4.73881 13.3442 4.36306 13.4105L0.87077 13.9926C0.826564 14 0.789725 14 0.745519 14C0.553959 14 0.362399 13.9189 0.222413 13.7789C0.052956 13.6095 -0.0280886 13.3663 0.00874987 13.1305L0.590798 9.63789C0.657107 9.2621 0.833932 8.91579 1.10654 8.64316L6.93438 2.82211ZM13.1159 0.884211C12.5486 0.309474 11.7971 0 10.994 0C10.1909 0 9.4394 0.309474 8.87208 0.884211L7.98059 1.77579L12.2244 6.02L13.1159 5.12842C13.6906 4.56105 14 3.80947 14 3.00632C14 2.20316 13.6906 1.45158 13.1159 0.884211Z",
    fill: "#474554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.869e2bbebe975e2fe9827047d31ae158.svg";
export { ForwardRef as ReactComponent };